import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function DispositionModal({
  open,
  isSandbox,
  onReturnToRunner,
  onSelectDisposition,
}) {
  const options = [
    { key: "sold", label: "Sold", variant: "default" },
    { key: "scheduled_cb", label: "Scheduled C/B", variant: "default" },
    { key: "no_scheduled_cb", label: "No Scheduled C/B", variant: "default" },
    { key: "dead_deal", label: "Dead Deal", variant: "default" },
  ];

  if (isSandbox) {
    options.push({ key: "testing", label: "Testing", variant: "amber" });
  }

  return (
    <Dialog open={open} onOpenChange={(v) => (!v ? onReturnToRunner?.() : null)}>
      <DialogContent className="glass border-white/10" data-testid="disposition-modal">
        <DialogHeader>
          <DialogTitle className="text-slate-100" data-testid="disposition-title">
            End of Run Disposition
          </DialogTitle>
          <DialogDescription
            className="text-slate-200/70"
            data-testid="disposition-description"
          >
            Select an End of Run disposition before closing.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-wrap gap-2" data-testid="disposition-options">
          {options.map((o) => (
            <Button
              key={o.key}
              variant={o.variant === "amber" ? "outline" : "default"}
              className={o.variant === "amber" ? "border-amber-500/50 text-amber-400 hover:bg-amber-500/20" : ""}
              onClick={() => onSelectDisposition?.(o.key)}
              data-testid={`disposition-option-${o.key}`}
            >
              {o.label}
            </Button>
          ))}
        </div>

        <DialogFooter>
          <Button
            variant="secondary"
            onClick={onReturnToRunner}
            data-testid="disposition-return"
          >
            Return to Runner
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
